import { REQUEST } from 'Stores'
import {
  GET_DATA_DASHBOARD, GET_DATA_TAB_CHART, GET_DATA_TOP_SEARCH
} from './constants'

export function getDataDashboard(payload) {
  return {
    type: REQUEST(GET_DATA_DASHBOARD),
    payload
  }
}

export function getDataTabChart(payload) {
  return {
    type: REQUEST(GET_DATA_TAB_CHART),
    payload
  }
}

export function getDataTopSearch(payload) {
  return {
    type: REQUEST(GET_DATA_TOP_SEARCH),
    payload
  }
}
